import React, { useRef } from "react";
import cx from "classnames";
import { useValidation } from "../../hooks/useValidation";
import { useForm } from "../../hooks/useForm";
import { InputErrorList } from "./InputErrorList";
import { InputIcon } from "./InputIcon";
import "./Input.scss";
export const PasswordInput = React.forwardRef(({ value, onChange, onBlur, placeholder, label, disabled = false, validators = [], forceValidation = false, readOnly = false, showPendingState = false, showSuccessState = false, }, ref) => {
    const inputName = useRef("password_" + Math.random().toString(36).substr(2, 9));
    const containerRef = useRef(null);
    const [validity, errorMessages, validityClasses, resetValidation] = useValidation(value, validators, forceValidation, showPendingState, showSuccessState);
    useForm(inputName.current, validity, value, resetValidation, containerRef, errorMessages, label);
    const classes = cx("lysa-ui-input", validityClasses, {
        "lysa-ui-input-read-only": readOnly,
    });
    return (React.createElement("div", { ref: containerRef, className: "lysa-ui-input-group" },
        React.createElement("label", { htmlFor: inputName.current }, label),
        React.createElement("div", { className: classes },
            React.createElement("input", { value: value, placeholder: placeholder, type: "password", id: inputName.current, name: "password", disabled: disabled, readOnly: readOnly, onChange: (event) => onChange && onChange(event.target.value), onBlur: () => onBlur && onBlur(), ref: ref, autoComplete: "current-password" }),
            React.createElement(InputIcon, null),
            React.createElement(InputErrorList, { errorMessages: errorMessages }))));
});
